import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { CrossTenantAccessPolicyDefault } from './actions';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'crossTenantAccessPolicy';

export interface State extends Status {
    data: CrossTenantAccessPolicyDefault;
}

export const initialState: State = {
    data: null,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,

    on(actions.loadCrossTenantAccessPolicySuccess, (state, action) => ({
        ...state,
        data: action.policy,
        error: false,
        loaded: true,
    })),
    on(actions.loadCrossTenantAccessPolicyFailure, (state, { error }) => ({
        ...state,
        error,
        loaded: false,
    })),

    on(actions.updateCrossTenantAccessPolicy, (state) => ({
        ...state,
        updating: true,
        error: null,
    })),

    on(actions.updateCrossTenantAccessPolicySuccess, (state, action) => ({
        ...state,
        data: action.policy,
        updating: false,
        error: false,
    })),

    on(actions.updateCrossTenantAccessPolicyFailure, (state, { error }) => ({
        ...state,
        error,
        updating: false,
    })),
);

export const selectPolicy = (state: State) => state.data;
export const selectError = (state: State) => state.error;
